export default "__VITE_ASSET__BsCBAlG9__"